import { render, staticRenderFns } from "./DonateDetail.vue?vue&type=template&id=92719ce4&scoped=true&"
import script from "./DonateDetail.vue?vue&type=script&lang=js&"
export * from "./DonateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92719ce4",
  null
  
)

export default component.exports